import { Paper, Typography } from '@material-ui/core';

const FeatureCard = ({ title, description, highlight = false }) => {
  const baseClasses =
    'flex-1 p-5 h-full text-center transition-colors duration-200 flex flex-col min-h-[120px]';
  const highlightClasses = highlight
    ? '!bg-[#063447] text-white border-none'
    : 'bg-stone-50 border-t-4 border-stone-600';

  return (
    <Paper className={`${baseClasses} ${highlightClasses}`} elevation={highlight ? 2 : 1}>
      <Typography
        variant="h6"
        component="h3"
        className={`mb-2 ${highlight ? '!text-white' : 'text-stone-800'}`}
        style={{ fontWeight: 700 }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        className={`${highlight ? '!text-white/90' : 'text-stone-600'} flex-grow`}
      >
        {description}
      </Typography>
    </Paper>
  );
};

export default FeatureCard;
